module.exports = __webpack_public_path__ + "img/mch_logo_icon.27447d54.png";